import { atom, useSetAtom } from 'jotai';
import { atomWithReset, atomWithStorage, useResetAtom } from 'jotai/utils';
import { companyIdAtom } from 'views/state';

export const sourceTypeAtom = atomWithStorage<string>(
  'ignoredqid_source_type',
  'was_data',
);

export const paginationConfigAtom = atomWithReset({
  page_size: 10, // Default page size
  page: 1,
});

export const DEFAULT_COLUMN_KEYS_IGNORED_QID = [
  'qid',
  'title',
  'severity',
  'actions',
];

export const orderbyAtom = atomWithReset<string>('qid');

export const sortOrderAtom = atomWithReset<'desc' | 'asc'>('asc');

export const forceRerenderIgnoreQidGridAtom = atom<string>('');

export const ignoredQidDataQueryParamsAtom = atom(async (get) => {
  const companyId = get(companyIdAtom);
  const paginationConfig = get(paginationConfigAtom);
  const orderBy = get(orderbyAtom);
  const order = get(sortOrderAtom);
  const ordering = `${order === 'desc' ? '-' : ''}${orderBy}`;
  const sourceType = get(sourceTypeAtom);

  if (companyId && companyId !== -1) {
    const params = {
      company_id: companyId.toString(),
      page: paginationConfig.page.toString(), // Specify the page number you want to retrieve
      page_size: paginationConfig.page_size.toString(), // Specify the number of items per page
      ordering: ordering, // Specify the field to sort by and the sorting order
      source_type: sourceType,
    };
    return params;
  }
  return undefined;
});

export const ignoredQidDataAtom = atom({
  results: [],
  count: 0,
  loading: false,
});

/**
 * reset the following atoms:
 * orderby
 * sort order
 * pagination
 */

export function useOnSourceTypeChangeResetAtoms() {
  const resetOrderbyAtom = useResetAtom(orderbyAtom);
  const resetSortOrderAtom = useResetAtom(sortOrderAtom);
  const resetPaginationConfigAtom = useResetAtom(paginationConfigAtom);

  const resetAtoms = () => {
    resetOrderbyAtom();
    resetSortOrderAtom();
    resetPaginationConfigAtom();
  };

  return resetAtoms;
}

export function useOnCompanyChangeIgnoredQIDTabConfigResetAtoms() {
  const resetRelatedAtoms = useOnSourceTypeChangeResetAtoms();
  const setSourceType = useSetAtom(sourceTypeAtom);

  const resetAtoms = () => {
    resetRelatedAtoms();
    setSourceType('was_data');
  };

  return resetAtoms;
}
